import { ReactNode, useState, Children, cloneElement, isValidElement } from 'react'

interface ExpandableCardListProps {
  children: ReactNode
  accordion?: boolean
  defaultExpandedId?: string
  className?: string
}

export function ExpandableCardList({
  children,
  accordion = true,
  defaultExpandedId,
  className = '',
}: ExpandableCardListProps) {
  const [expandedId, setExpandedId] = useState<string | null>(defaultExpandedId || null)

  const handleExpandedChange = (id: string, expanded: boolean) => {
    if (accordion) {
      setExpandedId(expanded ? id : null)
    }
  }

  return (
    <div className={`expandable-card-list ${className}`}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return child

        const childId = child.props.id
        if (!childId) return child

        return cloneElement(child, {
          ...child.props,
          expanded: accordion ? expandedId === childId : child.props.expanded,
          onExpandedChange: (expanded: boolean) => {
            handleExpandedChange(childId, expanded)
            child.props.onExpandedChange?.(expanded)
          },
        })
      })}
    </div>
  )
}
